import { Flex } from '@styles';
import { arrayOf, func, object } from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';

import { styles } from './CardMatching.styles';
import { Card, FinishCard } from './components';

const CardMatching = ({ cards, onFinish }) => {
  const [selectedCards, setSelectedCards] = useState([]);
  const [matchedCards, setMatchedCards] = useState([]);
  const [wrongChoicesAmount, setWrongChoicesAmount] = useState(0);

  const filteredCards = useMemo(
    () =>
      cards?.filter(
        (card) => !matchedCards.some((match) => match?.id === card?.id)
      ),
    [cards, matchedCards]
  );

  const isLoaded = useMemo(
    () => typeof filteredCards !== 'undefined',
    [filteredCards]
  );
  const firstColumn = useMemo(
    () => filteredCards?.slice(0, (filteredCards?.length || 0) / 2),
    [filteredCards]
  );
  const secondColumn = useMemo(
    () =>
      filteredCards?.slice(
        (filteredCards?.length || 0) / 2,
        filteredCards?.length
      ),
    [filteredCards]
  );

  useEffect(() => {
    if (selectedCards?.length === 2) {
      const isSelectionCorrect =
        selectedCards?.[0]?.match_id === selectedCards?.[1]?.id;
      if (isSelectionCorrect) {
        setTimeout(() => {
          setMatchedCards([...matchedCards, ...selectedCards]);
          setSelectedCards([]);
        }, 1000); // offset time to not appear flickery
      } else {
        setTimeout(() => {
          setSelectedCards([]);
          setWrongChoicesAmount((prevState) => prevState + 1);
        }, 1000);
      }
    }
  }, [selectedCards, matchedCards, filteredCards]);

  const onCardClick = (card) => () => {
    const newSelection = [...selectedCards];
    const indexOfCard = newSelection?.map((e) => e?.id).indexOf(card?.id);
    if (indexOfCard !== -1) {
      newSelection.splice(indexOfCard, 1);
    } else {
      newSelection.push(card);
    }
    setSelectedCards(newSelection);
  };

  const reset = () => {
    setMatchedCards([]);
    setSelectedCards([]);
    setWrongChoicesAmount(0);
  };

  return (
    <Flex flexDirection="row" gap={8}>
      {isLoaded &&
        (filteredCards?.length ? (
          <div style={styles.cardsContainer}>
            {firstColumn?.map((item, index) => (
              <>
                <Card
                  card={item}
                  onClick={onCardClick(item)}
                  selectedCards={selectedCards}
                />
                <Card
                  card={secondColumn[index]}
                  onClick={onCardClick(secondColumn[index])}
                  selectedCards={selectedCards}
                />
              </>
            ))}
          </div>
        ) : (
          <FinishCard
            onFinishButtonPress={onFinish}
            onTryAgainButtonPress={reset}
            status={wrongChoicesAmount ? 'fail' : 'success'}
          />
        ))}
    </Flex>
  );
};

CardMatching.propTypes = {
  cards: arrayOf(object).isRequired,
  onFinish: func.isRequired,
};

export default CardMatching;
